import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { Form } from "react-final-form";

import { TextField } from "~ui/atoms/Form/TextField/TextField";

const tAddNote = "Add Note";
const tCancel = "Cancel";
const tAdd = "Add";
const tBody = "Note";

interface AddNoteModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: { body: string; pinned: boolean }) => Promise<void>;
}

export const AddNoteModal = ({ open, onClose, onSubmit }: AddNoteModalProps) => {
  const handleSubmit = async (values: { body: string; pinned: boolean }) => {
    await onSubmit(values);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <Form
        onSubmit={handleSubmit}
        initialValues={{ body: "", pinned: false }}
        render={({ handleSubmit, submitting, hasValidationErrors, errors }) => (
          <form onSubmit={handleSubmit}>
            <DialogTitle>{tAddNote}</DialogTitle>
            <DialogContent>
              <Box display="grid" gap={2} py={1}>
                <TextField
                  name="body"
                  required
                  validate={(value) => (!value ? "Required" : undefined)}
                  textFieldProps={{
                    label: tBody,
                    multiline: true,
                    rows: 4,
                  }}
                />
              </Box>
            </DialogContent>
            <DialogActions>
              <Button onClick={onClose}>{tCancel}</Button>
              <Button
                type="submit"
                variant="contained"
                disabled={submitting || hasValidationErrors || Object.keys(errors || {}).length > 0}
              >
                {tAdd}
              </Button>
            </DialogActions>
          </form>
        )}
      />
    </Dialog>
  );
};
